import { useScaffold } from "@Light/scaffold";
import { Mail01, Phone } from "@untitledui/icons";
import clsx from "clsx";
import { ReactNode } from "react";

/** Call and email contact rows, sourced from the configured support details. */
export function SupportContactRows() {
  const scaffold = useScaffold();

  return (
    <div className="flex flex-col gap-6">
      {scaffold.page.supportPhone && (
        <ContactRow
          label="Call us"
          value={scaffold.page.supportPhone}
          subtext={scaffold.page.supportHours}
          href={`tel:${scaffold.page.supportPhone}`}
          icon={<Phone className="size-5" />}
        />
      )}

      {scaffold.page.supportEmail && (
        <ContactRow
          label="Send an email"
          value={scaffold.page.supportEmail}
          subtext="Typically respond within the same weekday."
          href={`mailto:${scaffold.page.supportEmail}`}
          icon={<Mail01 className="size-5" />}
        />
      )}
    </div>
  );
}

type ContactRowProps = {
  label: string;
  value: string;
  subtext?: string;
  href: string;
  icon: ReactNode;
};

function ContactRow({ label, value, subtext, href, icon }: ContactRowProps) {
  const scaffold = useScaffold();

  return (
    <div className="flex items-center gap-6">
      <div className="flex flex-1 min-w-0 flex-col gap-1">
        <div className="flex flex-col">
          <span
            className={clsx(
              "text-base font-semibold leading-6",
              scaffold.page.colors.text.label,
            )}
          >
            {label}
          </span>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={clsx(
              "text-base leading-6 underline truncate",
              scaffold.page.colors.text.primary,
            )}
          >
            {value}
          </a>
        </div>
        {subtext && (
          <span
            className={clsx(
              "text-sm leading-5",
              scaffold.page.colors.text.tertiary,
            )}
          >
            {subtext}
          </span>
        )}
      </div>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        className={clsx(
          "flex items-center justify-center rounded-full p-3 shrink-0 text-gray-200",
          scaffold.page.colors.button.background.plain,
        )}
      >
        {icon}
      </a>
    </div>
  );
}
